import React, { useLayoutEffect, useState } from 'react';
import cx, { Argument as ClassNameType } from 'classnames';

import cypressIds from 'CypressId';

import { applyCypressData } from 'Utilities/index';

import { VehiclePhotoBlock } from 'Storybook/components/local/VehiclePhotoBlock/VehiclePhotoBlock';

import styles from './BlockWithImages.module.scss';

type PhotoImageProps = {
  [key: string]: any;
  hasEmptyState: boolean;
  image?: string | null;
  imageClassName?: ClassNameType;
  label?: string;
}

export const PhotoImage = ({ hasEmptyState = false, imageClassName, ...props }: PhotoImageProps) => {
  const {
    image, label,
  } = props;

  const [isLoaded, setIsLoaded] = useState(false);

  useLayoutEffect(() => {
    if (hasEmptyState && !image) {
      setIsLoaded(true);
    }
  }, [hasEmptyState, image]);

  return (
    <VehiclePhotoBlock
      {...props}
      className={cx(imageClassName, styles.image, { [styles.imageDarkBG]: image, [styles.loaded]: isLoaded })}
      {...applyCypressData(cypressIds.sections.photoImage)}
      imageProps={{
        onError: () => setIsLoaded(true),
        onLoad: () => {
          setIsLoaded(true);
        },
      }}
      label={image && label ? label : undefined}
    />
  );
};
